import {WidgetErrorBanner} from 'shells/card/card-widget/widget-error-banner';
import {UrlRow} from 'shells/row/url-row/url-row';

import type {PeepBusinessCardInfoFragment_urls_all as Url} from 'nutshell-graphql-types';

import type {UserFacingEntity} from '../../../../core-entity/rows/peep-rows/types';

import {getTitleDropdownOptions} from '../helpers';
import type {PatchTitleInput, PatchUrlInput, RowErrorMessage} from '../types';

interface Props {
    urls: Url[] | null | undefined;
    canMarkAsPrimary: boolean;
    parentEntity: UserFacingEntity;
    labelOptions: string[] | null | undefined;
    newlyAddedId?: string | null;
    onUpdateUrl: (args: PatchUrlInput) => Promise<any>;
    onUpdateTitle: (args: PatchTitleInput) => Promise<any>;
    rowErrorMessage: RowErrorMessage | null;
    setRowErrorMessage: (rowErrorMessage: RowErrorMessage | null) => void;
}

export function UrlRowList(props: Props) {
    return (
        <>
            {props.urls?.map((url) => {
                if (!url.value) {
                    return null;
                }
                const errorMessage =
                    props.rowErrorMessage?.id === url.id
                        ? props.rowErrorMessage.errorMessage
                        : null;

                const dropdownOptions = getTitleDropdownOptions(
                    props.labelOptions,
                    url.id,
                    props.onUpdateTitle
                );

                return (
                    <div key={`${url.id}-url`}>
                        {errorMessage && (
                            <div className='pb-2 px-8'>
                                <WidgetErrorBanner
                                    error={errorMessage}
                                    setError={(error?: string | null) => {
                                        props.setRowErrorMessage(
                                            error
                                                ? {
                                                      id: url.id,
                                                      errorMessage: error,
                                                  }
                                                : null
                                        );
                                    }}
                                />
                            </div>
                        )}
                        <UrlRow
                            title={url.name}
                            url={url.value}
                            parentEntity={props.parentEntity}
                            displayValue={url.displayValue}
                            socialPlatform={url.socialPlatform}
                            isPrimary={url.isPrimary}
                            showIsPrimaryIcon={props.urls?.length !== 1}
                            canMarkAsPrimary={props.canMarkAsPrimary}
                            dropdownOptions={dropdownOptions}
                            onUpdateUrl={(updatedUrl: string) =>
                                props.onUpdateUrl({
                                    attributeValueId: url.id,
                                    urlInput: updatedUrl,
                                })
                            }
                            onMarkAsPrimary={() =>
                                props.onUpdateUrl({
                                    attributeValueId: url.id,
                                    isPrimary: true,
                                })
                            }
                            onDelete={() =>
                                props.onUpdateUrl({
                                    attributeValueId: url.id,
                                    isDelete: true,
                                })
                            }
                            onUpdateTitle={(title: string) =>
                                props.onUpdateTitle({
                                    attributeValueId: url.id,
                                    name: title,
                                })
                            }
                            successFlashKey={props.newlyAddedId === url.id ? url.id : undefined}
                        />
                    </div>
                );
            })}
        </>
    );
}
